/* =============================================================
   D'BakerAid Recipes — individual recipe page parser
   - Reads raw <div data-recipe>...</div> content from #recipe-data
   - Populates visible template slots in sections/recipe-single.liquid
   - Keeps template 100% decoupled from content — merchants only
     edit the Shopify page body, never this file or the template
   ============================================================= */

(function () {
  'use strict';

  var CATEGORY_MAP = {
    bread: 'Breads',
    breads: 'Breads',
    'rolls & buns': 'Rolls & Buns',
    'rolls and buns': 'Rolls & Buns',
    flatbreads: 'Flatbreads',
    sweet: 'Sweet',
    sourdough: 'Sourdough'
  };

  function text(el) {
    return el ? (el.textContent || '').trim() : '';
  }

  function show(el) { if (el) el.hidden = false; }
  function hide(el) { if (el) el.hidden = true; }

  function init() {
    var data = document.getElementById('recipe-data');
    if (!data) return;

    // --- Hero image ---
    var recipeRoot = data.querySelector('[data-recipe]');
    var imageUrl = recipeRoot ? recipeRoot.getAttribute('data-image') : '';
    var heroImageSlot = document.querySelector('[data-slot="hero-image"]');

    if (heroImageSlot) {
      heroImageSlot.innerHTML = '';

      if (imageUrl && imageUrl.trim()) {
        var img = document.createElement('img');
        img.src = imageUrl.trim();
        img.alt = document.querySelector('.recipe-hero__title')
          ? document.querySelector('.recipe-hero__title').textContent.trim()
          : 'Recipe image';
        img.loading = 'eager';
        heroImageSlot.appendChild(img);
      } else {
        heroImageSlot.classList.add('img-placeholder');
        heroImageSlot.innerHTML = '<span>Recipe photo coming soon</span>';
      }
    }

    // --- Intro ---
    var introEl = data.querySelector('[data-intro]');
    var introSlot = document.querySelector('[data-slot="intro"]');
    if (introSlot) {
      if (introEl && text(introEl)) {
        introSlot.textContent = text(introEl);
      } else {
        introSlot.textContent = '';
      }
    }

    // --- Time / Difficulty / Yield ---
    var timeEl = data.querySelector('[data-time]');
    var diffEl = data.querySelector('[data-difficulty]');
    var yieldEl = data.querySelector('[data-yield]');

    var timeBadge = document.querySelector('[data-slot="time-badge"]');
    var timeSlot = document.querySelector('[data-slot="time"]');
    if (timeEl && text(timeEl) && timeBadge && timeSlot) {
      timeSlot.textContent = text(timeEl);
      show(timeBadge);
    }

    var diffBadge = document.querySelector('[data-slot="diff-badge"]');
    var diffSlot = document.querySelector('[data-slot="difficulty"]');
    if (diffEl && text(diffEl) && diffBadge && diffSlot) {
      diffSlot.textContent = text(diffEl);
      show(diffBadge);
    }

    var yieldSlot = document.querySelector('[data-slot="yield"]');
    if (yieldEl && text(yieldEl) && yieldSlot) {
      yieldSlot.textContent = text(yieldEl);
      show(yieldSlot);
    }

    // --- Ingredients ---
    var ingRoot = data.querySelector('[data-ingredients]');
    var ingSlot = document.querySelector('[data-slot="ingredients"]');
    if (ingRoot && ingSlot) {
      ingSlot.innerHTML = '';
      var groups = ingRoot.querySelectorAll('[data-group]');

      if (groups.length === 0) {
        var singleUl = ingRoot.querySelector('ul, ol');
        if (singleUl) {
          var card = document.createElement('div');
          card.className = 'ingredient-group';
          var ulClone = singleUl.cloneNode(true);
          card.appendChild(ulClone);
          ingSlot.appendChild(card);
        }
      } else {
        groups.forEach(function (g, idx) {
          var title = g.getAttribute('data-group') || '';
          var ul = g.querySelector('ul, ol');
          var card = document.createElement('div');
          card.className = 'ingredient-group';

          var head = document.createElement('div');
          head.className = 'ingredient-group__head';

          var icon = document.createElement('span');
          icon.className = 'ingredient-group__icon';
          icon.textContent = String.fromCharCode(65 + idx);
          head.appendChild(icon);

          if (title) {
            var h = document.createElement('h3');
            h.className = 'ingredient-group__title';
            h.textContent = title;
            head.appendChild(h);
          }

          card.appendChild(head);

          if (ul) card.appendChild(ul.cloneNode(true));

          ingSlot.appendChild(card);
        });
      }
    }

    // --- Steps ---
    var stepsRoot = data.querySelector('[data-steps]');
    var stepsSlot = document.querySelector('[data-slot="steps"]');
    if (stepsRoot && stepsSlot) {
      stepsSlot.innerHTML = '';
      var steps = stepsRoot.querySelectorAll('[data-step]');
      steps.forEach(function (step, idx) {
        var number = step.getAttribute('data-step') || String(idx + 1);
        var title = step.getAttribute('data-title') || '';

        var li = document.createElement('li');
        li.className = 'step-card';

        var numEl = document.createElement('span');
        numEl.className = 'step-card__number';
        numEl.textContent = number;
        li.appendChild(numEl);

        var body = document.createElement('div');
        body.className = 'step-card__body';

        if (title) {
          var h = document.createElement('h3');
          h.textContent = number + '. ' + title;
          body.appendChild(h);
        }

        Array.prototype.forEach.call(step.children, function (child) {
          var clone = child.cloneNode(true);
          if (clone.hasAttribute && clone.hasAttribute('data-stage')) {
            var stage = document.createElement('span');
            stage.className = 'step-stage';
            stage.textContent = text(clone);
            body.appendChild(stage);
          } else {
            body.appendChild(clone);
          }
        });

        li.appendChild(body);
        stepsSlot.appendChild(li);
      });
    }

    // --- Note / Tip ---
    var noteEl = data.querySelector('[data-note]');
    var tipEl = data.querySelector('[data-tip]');
    var noteBlock = document.querySelector('[data-slot="note-block"]');
    var noteWrap = document.querySelector('[data-slot="note"]');
    var noteBody = document.querySelector('[data-slot="note-body"]');
    var tipWrap = document.querySelector('[data-slot="tip"]');
    var tipBody = document.querySelector('[data-slot="tip-body"]');

    var showNote = noteEl && text(noteEl);
    var showTip = tipEl && text(tipEl);

    if (showNote && noteBody) { noteBody.textContent = text(noteEl); show(noteWrap); }
    if (showTip && tipBody) { tipBody.textContent = text(tipEl); show(tipWrap); }
    if (noteBlock && (showNote || showTip)) show(noteBlock);

    // --- Tags ---
    var tagsEl = data.querySelector('[data-tags]');
    var tagsBlock = document.querySelector('[data-slot="tags-block"]');
    var tagsSlot = document.querySelector('[data-slot="tags"]');
    if (tagsEl && text(tagsEl) && tagsSlot && tagsBlock) {
      var parts = text(tagsEl).split(',').map(function (t) { return t.trim(); }).filter(Boolean);
      parts.forEach(function (t) {
        var a = document.createElement('a');
        var key = t.toLowerCase();
        var category = CATEGORY_MAP[key];
        if (category) {
          a.href = '/pages/recipes#filter=' + encodeURIComponent(category);
        } else {
          a.href = '/pages/recipes';
        }
        a.className = 'tag-pill';
        a.textContent = t;
        tagsSlot.appendChild(a);
      });
      show(tagsBlock);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();